import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetGameCountDto } from "../../../models/analytics/dto/get-game-count.dto";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_GAME_COUNT_QUERY_KEY = 'gameCount';

export const useGetGameCount = (locationId: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery<GetGameCountDto>({
        queryKey: [GET_GAME_COUNT_QUERY_KEY, locationId, startDate, endDate, filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            const dateSuffix = startDate && endDate ? `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetGameCountDto, {}>({ method: 'GET', endpoint: `analytics/game-count?locationId=${locationId}&${dateSuffix}${buildFilterSuffix(filters)}` });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
